const Button = ({ children, className }) => {
  const style = `bg-black text-white px-6 py-2 text-center  relative overflow-hidden hover:text-[#000] z-[1000] before:absolute before:left-0 before:top-0 before:bg-white before:h-full before:w-full before:transition before:ease-in before:duration-300 before:-translate-x-[100%] before:opacity-0 before:border before:border-black hover:before:translate-x-[0%] hover:before:opacity-100 before:z-[-1] ${className} `;
  return <button className={style}>{children}</button>;
};

export default Button;
